import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcDownload24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m6 22h12a3 3 0 0 0 3-3v-4c0-.563-.438-1-1-1-.563 0-1 .438-1 1v4c0 .563-.438 1-1 1h-12c-.563 0-1-.438-1-1v-4c0-.563-.438-1-1-1-.563 0-1 .438-1 1v4a3 3 0 0 0 3 3zm6-6c.25 0 .531-.093.719-.28l3.969-3.992a.902.902 0 0 0 .312-.717c0-.53-.438-.966-1-.966-.25 0-.531.093-.719.28l-2.281 2.276v-9.603c0-.561-.469-.998-1-.998-.563 0-1 .437-1 .998v9.602l-2.281-2.276a1.102 1.102 0 0 0 -.719-.28c-.563 0-1 .436-1 .997 0 .25.094.5.313.686l3.968 3.991c.188.188.469.281.719.281z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcDownload24;
